import React from 'react';
import PropTypes from 'prop-types';
import classes from 'classnames';
import {withRouter} from "react-router-dom";
import Vendor from './vendor';
import User from './user';
// import rs from '../../../config/router';

import {Button, buttonTypes} from '../../../components/Button';

import './Authentication.scss';

class SettingsBlock extends React.Component {
  constructor(props) {
    super(props);
    this.toggleShowSettings = this.toggleShowSettings.bind(this);
    this.state = {
      isShowSettings: false
    }
  }

  static propTypes = {
    history: PropTypes.object,
    user: PropTypes.object,
    isAuth: PropTypes.bool,
    vendorType: PropTypes.string,
    submitLogout: PropTypes.func,
    showLogin: PropTypes.func,
  };


  componentWillReceiveProps(next) {
    if (next.onMainClick && this.state.isShowSettings) {
      this.toggleShowSettings()
    }
  }

  toggleShowSettings() {
    this.setState({isShowSettings: !this.state.isShowSettings})
  }

  render() {

    const {
      history,
      isAuth,
      vendorType,
      showLogin,
      submitLogout,
      user,
    } = this.props;

    const {
      isShowSettings
    } = this.state;


    const isShow = classes('authentication__body isAuth',
      {
        active:
        isShowSettings ||
        history.location.pathname === '/profile' ||
        history.location.pathname === '/vendor' ||
        history.location.pathname === '/orders_list'
      });
    return (
      <div className="authentication">
        {
          isAuth ?
            <div className={isShow}>
              <Button
                title="profile"
                type={buttonTypes.DROPDOWN}
                name="Profile"
                className="ion-android-arrow-dropdown"
                onClick={this.toggleShowSettings}
              />
              {
                isShowSettings ?
                  <div className="authentication__drop-down">
                    {
                      vendorType === 'tour' ?
                        <Vendor
                          submitLogout={submitLogout}
                          user={user}
                        /> :
                        <User
                          submitLogout={submitLogout}
                        />
                    }
                  </div> :
                  null
              }

            </div> :
            <div className="authentication__body">
              {/* <Button
                name="Register"
                onClick={() => {
                  history.push(rs.register)
                }}
              /> */}
              <Button
                name="Login"
                onClick={() => {
                  showLogin()
                }}
              />
            </div>
        }
      </div>
    );
  }
}

export default withRouter(SettingsBlock);


// WEBPACK FOOTER //
// ./src/app/containers/Header/components/settingsBlock.js